<template>
    <div>
        <sweet-modal blocking ref="purchaseProjectTaskRequest" class="modal" v-on:close="closePurchaseProjectTaskRequest">
                <div style="display:flex; justify-content: center;">
                    <h2>Purchase Request Info</h2>
                </div>

                <el-table
                        :data="[form]"
                        style="width: 100%">
                    <el-table-column
                            v-if="action === 'editProject'"
                            :label="labelName">
                        <template slot-scope="scope">
                            {{scope.row.project.name}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Task">
                        <template slot-scope="scope">
                            {{scope.row.task.name}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Vendor">
                        <template slot-scope="scope">
                            {{scope.row.vendor.name}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Order Date">
                        <template slot-scope="scope">
                            <div v-if="scope.row.date">
                                {{moment(scope.row.date.toString(), 'X').format('D MMM YY')}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Current Credit">
                        <template slot-scope="scope">
                            {{formatPrice(scope.row.vendorCredit)}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Exchange Rate">
                        <template slot-scope="scope">
                            {{scope.row.exchageRate}} USD = 1 {{scope.row.vendorCurrency}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Reference">
                        <template slot-scope="scope">
                            {{scope.row.reference}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Deliver To">
                        <template slot-scope="scope">
                            {{scope.row.deliverTo}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Tax include">
                        <template slot-scope="scope">
                            {{scope.row.ifTax}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="WHTax">
                        <template slot-scope="scope">
                            <div v-if="scope.row.isWth">
                                Apply WHTax
                            </div>
                        </template>
                    </el-table-column>
                </el-table>

                <el-row :span="24" style="margin:20px 0;">
                    <el-collapse>
                        <el-collapse-item title="Description" name="1">
                            <div v-html="form.description"></div>
                        </el-collapse-item>
                    </el-collapse>
                </el-row>

                <el-row style="margin:20px 0;">
                    <el-button size="mini"
                               type="primary"
                               plain
                               @click="$refs.historyModal.open()">History</el-button>
                </el-row>

                <!--TABLE START -->
                Items
                <el-table
                        size="mini"
                        border
                        :data="form.items"
                        style="width: 100%"
                        @cell-click="cellClick">
                    <el-table-column
                            label="No."
                            width="80">
                        <template slot-scope="scope">
                            {{scope.row.code}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Name"
                            width="100">
                        <template slot-scope="scope">
                            {{scope.row.name}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Unit Price">
                        <template slot-scope="scope">
                            {{scope.row.amount}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Qty"
                            width="80">
                        <template slot-scope="scope">
                            {{scope.row.qty}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="VAT exclusive">
                        <template slot-scope="scope">
                            {{formatPrice(scope.row.vatExclusive)}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Tax">
                        <template slot-scope="scope">
                            {{scope.row.tax.name}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Unit"
                            width="80">
                        <template slot-scope="scope">
                            {{scope.row.unit.name}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="WHTax"
                            width="100px">
                        <template slot-scope="scope">
                            <div v-if="scope.row.withholdingTax">
                                {{scope.row.withholdingTax.name}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Required Delivery date">
                        <template slot-scope="scope">
                            {{moment(scope.row.date, 'X').format('DD MMM YYYY')}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Total">
                        <template slot-scope="scope">
                            {{formatPrice(scope.row.total)}}
                        </template>
                    </el-table-column>
                </el-table>
                <!--TABLE END -->

                <el-row :span="24" style="display:flex; justify-content: flex-end">
                    <el-col :span="12">
                        <div class="bill">
                            <h4 v-if="form.ifTax === 'Tax Exclusive'"><span>Subtotal</span><span> {{formatPrice(form.subTotal)}} </span></h4>
                            <h4 v-if="form.ifTax === 'Tax Exclusive'"><span>+ Tax of</span><span>{{formatPrice(form.taxOf)}}</span></h4>
                            <h4 v-if="form.ifTax === 'Tax Inclusive'"><span>Includes Tax of</span><span>{{ formatPrice(form.includesTaxOf)}} </span></h4>
                            <h4><span>Total Amount</span><span> {{formatPrice(form.totalAmount)}} </span> </h4>
                            <h4 v-if="form.isWth"><span>WHTax Amount</span><span>{{formatPrice(form.whtTaxAmount) }}</span></h4>
                            <el-divider></el-divider>
                            <div class="payment-to-vendor">
                                <h3><span>Payment to Vendor</span><span>{{formatPrice(form.paymentToVendor)}}</span></h3>
                            </div>
                        </div>
                    </el-col>
                </el-row>
        </sweet-modal>

        <!--HISTORY MODAL START-->
        <sweet-modal blocking ref="historyModal">
            <h3>History</h3>
            <div class="history-block">
                <div v-for="(item, index) in form.history" :key="index" class="row">
                    <el-row :span="24">
                        <el-col :span="12">
                            <el-button :type="item.action === 'create purchase request' ? 'primary' : item.action === 'reject purchase request' ? 'danger' : item.action === 'update purchase request' ? 'primary' : 'success'" plain size="mini">{{item.action}}</el-button>
                        </el-col>
                        <el-col :span="12">
                            {{moment(item.createdAt.toString(), 'x').format('lll')}}
                        </el-col>
                        <el-col v-if="item.action === 'reject purchase request'" :span="24">
                            <div>
                                {{item.description}}
                            </div>
                        </el-col>
                    </el-row>
                    <el-divider></el-divider>
                </div>
            </div>
        </sweet-modal>
        <!--HISTORY MODAL END-->

    </div>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue';


  export default {
    name: "purchaseRequestInfoModal",
    components:{
      SweetModal,

    },
    data() {
      return{
        moment:moment,
        action: 'editProject',
        labelName: 'Project',
        state: 'project',
        activePurchaseId: '',
        form:{
          project: {},
          task: {},
          vendor: {},
          date: null,
          vendorCurrency: "GBP",
          vendorCredit: '0',
          exchageRate: null,
          reference: null,
          deliverTo: null,
          description: null,
          itemsId:[],
          ifTax: 'Tax Inclusive',
          isWth: false,
          items:[],
          //bill
          subTotal: '0',
          taxOf: '0',
          totalAmount:'0',
          includesTaxOf: '0',
          whtTaxAmount: '0',
          paymentToVendor: '0',
          history: []
        }
      }
    },
    methods:{
      // open modal purchases
      async openModalInfo(companyId, projectId, projectTaskId, purchaseId, state, manager){
        this.activePurchaseId = purchaseId
        console.log('companyId, projectId, projectTaskId, purchaseId, state, manager', companyId, projectId, projectTaskId, purchaseId, state, manager)
        try {
          const urlParts = this.buildUrl(state)
          this.labelName = urlParts.labelName
          this.state = state

          //Get project list
          // this.projectList = await this.getProjectList(urlParts.routeName)

          //Get task list
          if(!projectTaskId){
            this.action = 'editProject'
            //Get purchase item if project
            await this.getPurchaseItem(state, purchaseId)
          }else if(projectId){
            this.action = 'editTask'
            //Get purchase item if task
            await this.getPurchaseItem(urlParts.stateTask, purchaseId)
          }

          this.$refs.purchaseProjectTaskRequest.open()

        }catch (err){
          console.log(err)
        }
      },
      getPurchaseItem(type, purchaseId){
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .get(`/api/v1/purchaseRequest/item?type=${type}&id=${purchaseId}`)
            .then(response => {
                this.form.vendor = response.data.item.purchaseRequest.vendor,
                this.form.date = response.data.item.purchaseRequest.orderDate,
                this.form.vendorCurrency = response.data.item.purchaseRequest.vendorCurrency,
                this.form.vendorCredit = response.data.item.purchaseRequest.vendorCredit,
                this.form.exchageRate = response.data.item.purchaseRequest.exchageRate,
                this.form.reference = response.data.item.purchaseRequest.reference,
                this.form.deliverTo = response.data.item.purchaseRequest.deliverTo,
                this.form.itemsId = response.data.item.purchaseRequest.items.map(item => item.id)
                this.form.ifTax = response.data.item.purchaseRequest.includeTax ? 'Tax Exclusive' : 'Tax Inclusive',
                this.form.isWth = response.data.item.purchaseRequest.inludeWth,
                this.form.description = response.data.item.purchaseRequest.description,
                //bill
                this.form.subTotal = response.data.item.purchaseRequest.subTotal,
                this.form.taxOf = response.data.item.purchaseRequest.taxOf,
                this.form.totalAmount = response.data.item.purchaseRequest.totalAmount,
                this.form.includesTaxOf = response.data.item.purchaseRequest.includeTax,
                this.form.whtTaxAmount = response.data.item.purchaseRequest.whtTaxAmount,
                this.form.paymentToVendor = response.data.item.purchaseRequest.paymentToVendor

              switch(type){
                case 'project':
                  this.form.project = response.data.item.project
                  break;
                case 'projectTask':
                  this.form.task = response.data.item.projectTask
                  break;
                case 'engagement':
                  this.form.project = response.data.item.engagament
                  break;
                case 'engagementTask':
                  this.form.task = response.data.item.engagamentTask
                  break;
                case 'businessUnit':
                  this.form.project = response.data.item.businessUnit
                  break;
                case 'businessUnitTask':
                  this.form.task = response.data.item.businessUnitTask
                  break;
              }

              // create item list
              const items = []
              response.data.item.purchaseRequest.items.forEach(val => {
                const item = {
                  id: val.id,
                  originalItemId: val.originalItemId,
                  code: val.code,
                  name: val.name,
                  tax: val.tax,
                  unit: val.unit,
                  wtx: val.withholdingTax,
                  amount: val.amount,
                  taxId: val.taxId,
                  itemWhTaxName: val.withholdingTax ? val.withholdingTax.name : null,
                  qty: val.qty,
                  date: val.date * 1000,
                  vatExclusive: val.vatExclusive,
                  total: val.total,
                }
                items.push(item)
              })

              this.form.items = response.data.item.purchaseRequest.items
              this.form.history = response.data.item.purchaseRequest.history
              resolve(response.data.item)
            }).catch(error =>{
            console.log(error)
            reject(error)
          })
        })
      },
      closePurchaseProjectTaskRequest(){
          this.form.vendor = {}
          this.form.task = {}
          this.form.project = {}
          this.form.date = ''
          this.form.vendorCurrency = ''
          this.form.vendorCredit = ''
          this.form.exchageRate = ''
          this.form.reference = ''
          this.form.deliverTo = ''
          this.form.itemsId = ''
          this.form.ifTax = ''
          this.form.isWth = ''
          this.form.description = ''
          //bill
          this.form.subTotal = '0'
          this.form.taxOf = '0'
          this.form.totalAmount = '0'
          this.form.includesTaxOf = '0'
          this.form.whtTaxAmount = '0'
          this.form.paymentToVendor = '0'
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      cellClick(row, column, event){
        console.log('row', row)
        console.log('column', column)
      },
      buildUrl(state) {
        let routeName = ''
        let labelName = ''
        let stateProjectId = ''
        let projectId = ''
        let stateTaskId = ''
        let taskId = ''
        let stateExpenseId = ''
        let stateProjectTasks = ''
        let stateTask = ''
        switch (state){
          case 'project':
            routeName = 'projects'
            labelName = 'Project'
            stateProjectId = 'projectId'
            stateProjectTasks = 'projectTasks'
            stateTaskId = 'projectTaskId'
            stateExpenseId = 'projectTaskPurchaseId'
            stateTask = 'projectTask'
            break;
          case 'engagement':
            routeName = 'engagements'
            stateProjectId = 'engagementId'
            stateTaskId = 'engagementTaskId'
            stateProjectTasks = 'engagementTasks'
            stateExpenseId = 'engagementTaskPurchaseId'
            labelName = 'Engagement'
            stateTask = 'engagementTask'
            break;
          case 'businessUnit':
            routeName = 'businessUnits'
            stateProjectId = 'businessUnitId'
            stateTaskId = 'businessUnitTaskId'
            stateProjectTasks = 'businessUnitTasks'
            stateExpenseId = 'businessUnitTaskPurchaseId'
            labelName = 'Business Unit'
            stateTask = 'businessUnitTask'
            break;
        }
        return {
          state: state,
          routeName: routeName,
          stateProjectId: stateProjectId,
          labelName: labelName,
          projectId: projectId,
          stateTaskId: stateTaskId,
          stateProjectTasks: stateProjectTasks,
          taskId: taskId,
          stateExpenseId: stateExpenseId,
          stateTask: stateTask }
      }
    }
  }
</script>

<style lang="less" scoped>
    /deep/.el-date-editor.el-input, .el-date-editor.el-input__inner {
        width:100%;
    }
    /deep/.sweet-modal-overlay{
        z-index:1000;
        .sweet-modal {
            max-width: 100% !important;
        }
    }
    .bill{
        text-align:right;
        h4{
            line-height:0.6;
            span{
                padding: 0 10px;
            }
        }
        .payment-to-vendor{
            background: rgb(227, 228, 230);
            h3{
                span{
                    padding: 0 10px;
                }
            }
        }
    }
    .row{
        margin:20px 0;
    }
</style>
